export const EMAIL_TAGS = {
  LINK: { id: '28eb7ca9-b0c6-4751-978a-cf1091870fe9', name: 'Link' },
  PAYLOAD: { id: 'f1334261-d876-4a53-8751-d09cd13ec6eb', name: 'Payload' },
  RESPONSE: { id: '66bf98c9-231c-4b21-8dc8-17151d6ca585', name: 'Response' },
}

export const isTagValidForEmails = (tag: any) => {
  if (tag.organization_id != null) {
    // all local tags should be allowed
    return true
  }

  return Object.values(EMAIL_TAGS).some((emailTag) => emailTag.id === tag.id)
}
